/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentMethodPrice } from './paymentMethodPrice';
import { OfferImage } from './offerImage';


export interface PaymentMethodInternal { 
    /**
     * Unique identifier of the payment method
     */
    id?: string;
    price?: PaymentMethodPrice;
    image?: OfferImage;
}

